var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 48,
    viewBox: "0 0 480 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5713 7.5314L53.3894 0.372803H427.494L439.418 7.5314",
    stroke: "#D0AF79",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M439.418 40.001L426.6 47.1595L52.4952 47.1595L40.5716 40.0009",
    stroke: "#D0AF79",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1327 23.7662H0.0161133",
    stroke: "#D0AF79",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1325 17.8293L13.5742 12.4918",
    stroke: "#D0AF79",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.574 35.0405L27.1323 29.703",
    stroke: "#D0AF79",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M452.857 23.7661L479.974 23.7661",
    stroke: "#D0AF79",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M452.857 29.703L466.415 35.0405",
    stroke: "#D0AF79",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M466.416 12.492L452.857 17.8295",
    stroke: "#D0AF79",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextFrame);
export default __webpack_public_path__ + "static/media/textFrame.16196566be79bf18dd26c4d36b8b7f86.svg";
export { ForwardRef as ReactComponent };